import 'slick-carousel/slick/slick.css'
import Slick from 'vue-slick'

export default {
  components: {
    Slick
  },
  props: ['slides', 'initialSlide'],
  data () {
    return {
      slickOptions: {
        slidesToShow: 1,
        arrows: false,
        swipe: false,
        initialSlide: this.initialSlide || 0
      },
      currentSlide: this.initialSlide || 0
    }
  },
  methods: {
    afterChange ($event, slide, currentSlide) {
      this.currentSlide = currentSlide
    },
    prev () {
      this.$refs.slick.prev()
    },
    next () {
      this.$refs.slick.next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/game/question/slider/slider.js